import { useLocation, Link } from "react-router-dom";

interface LocationState {
  email?: string;
}

export default function CheckEmail() {
  const location = useLocation();
  const state = (location.state as LocationState | null) ?? null;
  const email = state?.email ?? "your inbox";

  return (
    <div className="auth-shell">
      <div className="auth-card" data-testid="check-email">
        <h1 className="auth-title">Check your email</h1>
        <p className="auth-sub">
          We sent a link to <strong>{email}</strong>. Check your inbox. Links
          expire in 10 minutes.
        </p>
        <Link
          to="/login"
          style={{ color: "var(--text-muted)", fontSize: 13 }}
        >
          ← Use a different email
        </Link>
      </div>
    </div>
  );
}
